module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<tr class="documentosItem">\r\n    <td>\r\n        ';
 if(attributes.documento_file){ 
__p+='\r\n            <input type=\'text\' id="documento_filename" class="form-control" disabled readonly value="'+
((__t=(attributes.documento_file))==null?'':_.escape(__t))+
'" />\r\n            <input type="file" id="documento_file" class="form-control hidden" />\r\n            ';
} else { 
__p+='\r\n                <input type="file" id="documento_file" class="form-control" />\r\n                ';
 } 
__p+='\r\n\r\n    </td>\r\n    <td class="text-center">\r\n        ';
  
 
        if(attributes.documento_file){
            var folder = (attributes.item_id)?attributes.item_id:attributes.good_id;
            var idInstance = (idInstance)?idInstance:0;
            var id_file_ix = attributes.id;

            

            
            /*
              print('<a target="_blank" href="files/documents/'  + idInstance +'/'+ folder + '/' + attributes.documento_file + '"><span class="tableIcon glyphicon glyphicon-file"></span></a>');

                print('<a target="_blank" href="a_cces.php?id_inst='  + '1-'+ idInstance +'-9&_toke='+t_oken + '&fil_a='+attributes.documento_file+'&fold_id='+'5-'+folder+'"><span class="tableIcon glyphicon glyphicon-file"></span></a>');
                
            */
            
__p+='\r\n\r\n            <form action="a_cces.php?document='+
((__t=(attributes.documento_file))==null?'':_.escape(__t))+
'" id="acces_form_c_'+
((__t=(id_file_ix))==null?'':_.escape(__t))+
'" target="_blank" method="post">\r\n\r\n                <input type="hidden" name="id_inst" id="id_inst" value="1-'+
((__t=(idInstance))==null?'':_.escape(__t))+
'-9">\r\n                <input type="hidden" name="fil_a" id="fil_a" value="'+
((__t=(attributes.documento_file))==null?'':_.escape(__t))+
'">\r\n                <input type="hidden" name="_tok" id="_tok" value="'+
((__t=(t_oken))==null?'':_.escape(__t))+
'">\r\n                <input type="hidden" name="fold_id" id="fold_id" value="5-'+
((__t=(folder))==null?'':_.escape(__t))+
'">\r\n\r\n                <span onclick="document.forms[\'acces_form_c_'+
((__t=(id_file_ix))==null?'':_.escape(__t))+
'\'].submit(); return false;" class="tableIcon glyphicon glyphicon-file colll_oodd"></span>\r\n            </form>\r\n            ';

            
          
        }
        
__p+='\r\n    </td>\r\n    <td>\r\n        <textarea id="documento_desc" class="form-control" '+
((__t=(disabled))==null?'':_.escape(__t))+
'>'+
((__t=(attributes.documento_desc))==null?'':_.escape(__t))+
'</textarea>\r\n    </td>\r\n\r\n    <td>\r\n        <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n    </td>\r\n</tr>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/documentos.ejs
// module id = 156
// module chunks = 0